import React from 'react'
import { Flex, Text, TextVariant, Button } from '@mprolab/uikit'
import styled, { useTheme } from 'styled-components'
import { useRouter } from 'hooks/useRouter'

export const TableWrapper = styled(Flex)`
  gap: 24px;
  width: 100%;
  height: 100%;
  min-height: 301px;
  padding: 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.colors.backgroundContrast};
  ${({ theme }) => theme.mediaQueries.mobile} {
    margin-bottom: 32px;
  }
`

interface EmptyRewardsProps {
  title: string
  description: string
  buttonText: string
  redirectTo: string
}

const EmptyRewards: React.FC<EmptyRewardsProps> = ({ title, description, buttonText, redirectTo }) => {
  const { colors } = useTheme()
  const { push } = useRouter()

  return (
    <TableWrapper>
      <Flex flexDirection="column" gap="8px" alignItems="center">
        <Text textAlign="center" variant={TextVariant.BODY_BIG_BOLD}>
          {title}
        </Text>
        <Text textAlign="center" color={colors.gray6}>
          {description}
        </Text>
      </Flex>
      <Button onClick={() => push(redirectTo)}>{buttonText}</Button>
    </TableWrapper>
  )
}

export default EmptyRewards
